import { ApolloLink } from 'apollo-link';
import authLink from './authLink';
import errorLink from './errorLink';
import httpLink from './httpLink';

const link = ApolloLink.from([
  authLink,
  errorLink,
  httpLink,
]);

export default link;



// WEBPACK FOOTER //
// ./src/data/links/index.js